document.addEventListener('DOMContentLoaded', function () {
  var wrappers = document.querySelectorAll('[data-video-banner]');

  wrappers.forEach(function (wrapper) {
    var videos = wrapper.querySelectorAll('video');
    if (!videos.length) return;

    var muteButton = wrapper.querySelector('[data-mute-toggle]');
    var playButton = wrapper.querySelector('[data-bg-video-play]');

    function setMuted(isMuted) {
      videos.forEach(function (video) {
        video.muted = isMuted;
      });

      if (muteButton) {
        muteButton.dataset.muted = isMuted ? 'true' : 'false';
        muteButton.setAttribute(
          'aria-label',
          isMuted ? 'Unmute video' : 'Mute video'
        );
      }
    }

    // --- Init mute button from first video state ---
    if (muteButton) {
      var initialMuted = videos[0].muted;
      muteButton.dataset.muted = initialMuted ? 'true' : 'false';
      muteButton.setAttribute(
        'aria-label',
        initialMuted ? 'Unmute video' : 'Mute video'
      );

      muteButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var currentlyMuted = muteButton.dataset.muted === 'true';
        setMuted(!currentlyMuted);
      });
    }

    // --- Center play button: restart, unmute, play, hide button ---
    if (playButton) {
      playButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        videos.forEach(function (video) {
          try {
            video.currentTime = 0;
          } catch (e) {
            // ignore if not seekable yet
          }

          video.muted = false;

          var playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise.catch(function () {
              // browser might still block, ignore
            });
          }
        });

        if (muteButton) {
          muteButton.dataset.muted = 'false';
          muteButton.setAttribute('aria-label', 'Mute video');
        }

        // Hide big play button via CSS
        wrapper.dataset.videoPlaying = 'true';
      });
    }

    // --- Auto-mute when the section leaves the viewport ---
    function autoMuteWhenOutOfView() {
      // Only matters if it was unmuted
      if (muteButton && muteButton.dataset.muted === 'false') {
        setMuted(true);
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            // When the section is no longer visible at all
            if (!entry.isIntersecting) {
              autoMuteWhenOutOfView();
            }
          });
        },
        {
          threshold: 0.1 // consider "visible" if at least 10% is on-screen
        }
      );

      observer.observe(wrapper);
    } else {
      // Fallback for older browsers: scroll listener
      function checkVisibility() {
        var rect = wrapper.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;

        var completelyBelow = rect.top >= vh;
        var completelyAbove = rect.bottom <= 0;

        if (completelyAbove || completelyBelow) {
          autoMuteWhenOutOfView();
        }
      }

      window.addEventListener('scroll', checkVisibility);
      window.addEventListener('resize', checkVisibility);
      checkVisibility();
    }
  });
});
